import { render, staticRenderFns } from "./conversao-rating.vue?vue&type=template&id=20940ee5&"
import script from "./conversao-rating.vue?vue&type=script&lang=js&"
export * from "./conversao-rating.vue?vue&type=script&lang=js&"
import style0 from "./conversao-rating.vue?vue&type=style&index=0&lang=sass&scope=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VSimpleTable,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20940ee5')) {
      api.createRecord('20940ee5', component.options)
    } else {
      api.reload('20940ee5', component.options)
    }
    module.hot.accept("./conversao-rating.vue?vue&type=template&id=20940ee5&", function () {
      api.rerender('20940ee5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modal/conversao-rating.vue"
export default component.exports